import React from 'react'
import styles from "./InfoCard.module.css";

export const InfoCard = ({ title, Detail, color, fontmultiplyer = 1, img }) => {
    const textsize = fontmultiplyer * 1.5.toString() + "em";
    return (
        <div className={styles.card} >
            <div className={styles.cardinner} >
                <div className={styles.cardfront} >
                    <img className={styles.imageclass} width="100%" height="100%" src={img} alt="Logo" />



                    <h2 className={styles.title}>
                        {title}
                    </h2>
                </div>
                <div className={styles.cardback} style={{ background: color }} >

                    <div className={styles.container}>
                        <h3 className={styles.cardbacktitle} style={{ fontSize: textsize }}>{title}</h3>
                        <p className={styles.cardbackdetails} style={{ fontSize: textsize }}>{Detail}</p>

                    </div>


                </div>
            </div>
        </div>
    )
}
